import { Redirect } from "expo-router";

import { staffPath } from "../../../src/lib/hosting";

export default function LegacyDirectorWorkspaceRedirect() {
  return <Redirect href={staffPath("/admin")} />;
}
